// extracted by mini-css-extract-plugin
module.exports = {"untilText":"az_bSc","closeText":"az_cSc"};